<template>
    <div class="flex h-full">
        <ai-tree-list-edit :toolbarShow="false" ref="treeListRef" :meta="meta"></ai-tree-list-edit>
        <div class="flex flex-col h-full gap-2">
            <ai-grid-ro ref="gridRef" :showToolbar="false" :args="args" :meta="gridMeta" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'calculation-string-algorithm',
};
</script>
<script setup>
import { onMounted, ref } from 'vue';
import { meta, gridMeta } from './meta';

const treeListRef = ref();
const treeListInstance = ref();
const gridRef = ref();

onMounted(() => {
    treeListInstance.value = treeListRef.value.treeListInstance;
    treeListInstance.value.on('focusedRowChanged', onFocusRowChangedHandler);
});

const onFocusRowChangedHandler = event => {
    gridRef.value.setDataSource(gridMeta.api.select, {
        select_args: {
            parent: event.row?.data?.kod_spr_smet,
        },
    });
};

const args = {
    select: {
        select_args: {
            parent: null,
            currentCode: null,
        },
    },
};
</script>

<style>
.gridContainer {
    width: 100%;
    overflow-x: auto;
}
</style>
./meta
